import React from 'react';
import { useLocation } from 'react-router-dom';
const TAGLINES: Record<string, string> = {
  '/': 'meetsynthia · instruction governance — governing what AI models are told · patents pending',
  '/how': 'meetsynthia · the instruction layer · patents pending',
  '/contact': 'meetsynthia · the instruction layer · patents pending',
  '/blog': 'meetsynthia · signals from the instruction layer · patents pending'
};
export function Footer() {
  const {
    pathname
  } = useLocation();
  // Post pages sit under /blog/<slug> and carry the Signals tagline too.
  const key = pathname.startsWith('/blog') ? '/blog' : pathname;
  return <footer data-id="element-47" data-mp="3ldkgncakmqtt">
      <span data-id="element-48" data-mp="3le2j4qntu1a6">{TAGLINES[key] ?? TAGLINES['/']}</span>
      <span data-id="element-49" data-mp="3qcx9qes1cu4u">
        <a href="mailto:hello@meetsynthia.ai" data-id="element-50" data-mp="3qcdsl0a7m9rv">hello@meetsynthia.ai</a> &middot; &copy; 2026 Synthia
      </span>
    </footer>;
}